import React from 'react';
import WelcomeSection from '../components/dashboard/HeaderComponents/WelcomeSection';
import StatisticsGrid from '../components/dashboard/StatisticsComponents/StatisticsGrid';
import QuickActionsGrid from '../components/dashboard/QuickActionsComponents/QuickActionsGrid';
import RecentActivity from '../components/dashboard/RecentActivityComponents/RecentActivity';
import DashboardLayout from '../components/layout/DashboardLayout';
import DashboardSection, { 
  QuickActionsSection, 
  RecentActivitySection 
} from '../components/layout/DashboardSection';
import { useDashboardData } from '../hooks/useDashboardData';
import { useDashboardStatistics } from '../hooks/useDashboardStats';
import LoadingState from '../components/ui/LoadingState';

const Dashboard = () => {
  // Use the centralized dashboard data hook
  const {
    claims,
    users,
    user,
    userRoles,
    isUsersLoading,
    isUsersError,
    isAuthLoaded
  } = useDashboardData();

  // Fetch statistics from backend API instead of frontend calculation
  const { statistics, isLoading: isStatsLoading, isError: isStatsError, refetch: refetchStats } = useDashboardStatistics();

  // Simple values instead of memoization
  const dashboardTitle = userRoles.includes('Claims_Officer') ? "Claims Processing Dashboard" : "";
  const quickActionsSubtitle = userRoles.includes('Claims_Officer') ? "Claims processing tools and workflows" : "Frequently used actions based on your role";


  return (
    <DashboardLayout>
      {/* Show loading state if auth isn't loaded yet, but keep component mounted */}
      {!isAuthLoaded ? (
        <div className="flex justify-center items-center min-h-[400px]">
          <LoadingState 
            size="large"
            text="Loading dashboard..."
            variant="spinner"
            fullScreen={false}
          />
        </div>
      ) : (
        <>
          {/* Welcome Section */}
          <DashboardSection spacing="default">
            <WelcomeSection />
          </DashboardSection>

          {/* Statistics Cards */}
          <DashboardSection
            title={dashboardTitle}
            spacing="default"
            isLoading={isStatsLoading}
            error={isStatsError ? "Failed to load statistics" : null}
            onRetry={refetchStats}
            withErrorBoundary={true}
          >
            <StatisticsGrid 
              stats={statistics}
              isLoading={isStatsLoading}
              isError={isStatsError}
              isUsersLoading={isUsersLoading}
              isUsersError={isUsersError}
              onRefresh={refetchStats}
            />
          </DashboardSection>

          {/* Quick Actions Grid */}
          <QuickActionsSection
            title="Quick Actions"
            subtitle={quickActionsSubtitle}
            spacing="default"
          >
            <QuickActionsGrid />
          </QuickActionsSection>
        </>
      )}

      {/* Recent Activity - Always render to prevent mount/unmount cycles */}
      <RecentActivitySection spacing="none">
        <RecentActivity />
      </RecentActivitySection>
    </DashboardLayout>
  );
};

export default Dashboard;
